import { render, staticRenderFns } from "./VendorUsers.vue?vue&type=template&id=4084da86"
import script from "./VendorUsers.vue?vue&type=script&lang=js"
export * from "./VendorUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports